import { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Heading, Pilcrow, Undo, Redo } from "lucide-react";

/** Dependency-free, mobile-friendly rich-text editor (contentEditable). Emits sanitized-on-server HTML. */
export default function RichTextEditor({ value, onChange, testId }) {
  const ref = useRef();

  useEffect(() => {
    try { document.execCommand("defaultParagraphSeparator", false, "p"); } catch (e) { /* noop */ }
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => onChange(ref.current?.innerHTML || "");
  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    emit();
  };

  const Btn = ({ cmd, arg, label, icon: Icon }) => (
    <button
      type="button"
      aria-label={label}
      title={label}
      onMouseDown={(e) => { e.preventDefault(); exec(cmd, arg); }}
      className="p-2.5 rounded-md hover:bg-[#E9DAF4] text-[#32104F] transition-colors min-w-[40px] min-h-[40px] flex items-center justify-center"
    >
      <Icon className="w-4 h-4" strokeWidth={1.8} />
    </button>
  );

  return (
    <div className="border border-[#CBB4E4] rounded-md bg-white overflow-hidden">
      <div className="flex flex-wrap gap-0.5 border-b border-[#E7D8C6] p-1.5 bg-[#FBF4FF] sticky top-0 z-10">
        <Btn cmd="bold" label="Fett" icon={Bold} />
        <Btn cmd="italic" label="Kursiv" icon={Italic} />
        <Btn cmd="underline" label="Unterstrichen" icon={Underline} />
        <span className="w-px bg-[#E7D8C6] mx-1 my-1" />
        <Btn cmd="formatBlock" arg="h3" label="Überschrift" icon={Heading} />
        <Btn cmd="formatBlock" arg="p" label="Absatz" icon={Pilcrow} />
        <Btn cmd="insertUnorderedList" label="Liste" icon={List} />
        <Btn cmd="insertOrderedList" label="Nummerierte Liste" icon={ListOrdered} />
        <span className="w-px bg-[#E7D8C6] mx-1 my-1" />
        <Btn cmd="undo" label="Rückgängig" icon={Undo} />
        <Btn cmd="redo" label="Wiederholen" icon={Redo} />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        data-testid={testId}
        onInput={emit}
        onBlur={emit}
        className="poem-body min-h-[260px] p-4 text-xl leading-relaxed outline-none text-[#32104F]"
      />
    </div>
  );
}
